const rows = [
  { label: 'Стоимость', training: 'Каждый тренинг — отдельная оплата. Затраты растут линейно с количеством обучений.', academy: 'Инвестиция в систему. После запуска стоимость на сотрудника снижается с каждым циклом.' },
  { label: 'Эффект', training: 'Краткосрочный: 2-4 недели после тренинга, затем навыки угасают без поддержки.', academy: 'Долгосрочный: непрерывное развитие, накопление знаний, рост компетенций компании.' },
  { label: 'Масштабируемость', training: 'Ограничена: каждый новый сотрудник требует нового цикла обучения с нуля.', academy: 'Высокая: система тиражируется на новых сотрудников без дополнительных затрат.' },
  { label: 'Передача знаний', training: 'Знания остаются у участников тренинга. При их уходе компания теряет экспертизу.', academy: 'Знания зафиксированы в базе знаний, регламентах и программах. Остаются в компании.' },
  { label: 'Развитие сотрудников', training: 'Точечное: развиваются конкретные навыки под конкретную задачу.', academy: 'Системное: развитие по карьерным трекам, индивидуальные планы, преемственность.' },
  { label: 'Адаптация новичков', training: 'Не влияет. Адаптация зависит от конкретного руководителя.', academy: 'Стандартизированный онбординг: чек-листы, наставники, welcome-программа.' },
  { label: 'Управление знаниями', training: 'Отсутствует. Материалы разбросаны по файлам, ссылкам и чатам.', academy: 'Централизованная база знаний: единый источник правды для всей компании.' },
];

export default function AcademyVsExternal() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Корпоративная академия или внешнее обучение?
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Сравним два подхода к развитию персонала. Разовые тренинги решают тактические задачи, корпоративная академия — стратегические.
        </p>

        <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
          {/* Header */}
          <div className="grid grid-cols-4 bg-teal-600 text-white">
            <div className="p-5 font-bold text-sm">Параметр</div>
            <div className="col-span-1 p-5 font-bold text-sm text-center border-x border-teal-500">Разовые тренинги</div>
            <div className="col-span-2 p-5 font-bold text-sm text-center">Корпоративная академия</div>
          </div>

          {/* Rows */}
          {rows.map((row, i) => (
            <div key={i} className={`grid grid-cols-4 border-b border-gray-200 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
              <div className="p-5 font-semibold text-gray-900 text-sm flex items-center">{row.label}</div>
              <div className="col-span-1 p-5 text-gray-600 text-sm border-x border-gray-200 leading-relaxed">{row.training}</div>
              <div className="col-span-2 p-5 text-gray-600 text-sm leading-relaxed bg-teal-50/50">{row.academy}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}